var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27052_371112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "url(#paint0_linear_27052_371112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.528 23.6159C16.672 24.0319 18.528 22.4 18.528 20.3199C18.528 19.2319 17.984 18.2399 17.152 17.6319L17.1519 10.3039C17.1519 9.21592 16.2879 8.31995 15.1679 8.31995C14.0799 8.31995 13.1839 9.21593 13.1839 10.3039V17.6319C12.192 18.3679 11.6159 19.6159 11.9039 21.0239C12.16 22.3039 13.216 23.3599 14.5279 23.6159H14.528ZM13.6 18.2399L13.888 18.0159V10.3359C13.888 9.63192 14.464 9.08791 15.136 9.08791C15.84 9.08791 16.416 9.66389 16.416 10.3359V18.0159L16.704 18.2399C17.376 18.7199 17.76 19.5199 17.76 20.3519C17.76 21.056 17.472 21.7279 16.992 22.2079C16.48 22.6879 15.84 22.976 15.136 22.976C13.824 22.976 12.8 22.0479 12.576 20.896C12.4159 19.84 12.8 18.816 13.6 18.24V18.2399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.168 22.208C15.68 22.208 16.16 22.016 16.512 21.664C16.864 21.312 17.056 20.832 17.056 20.32C17.056 19.04 15.968 18.624 15.68 18.368L15.6799 12.96H14.624V18.368C14.3999 18.6239 12.992 19.136 13.312 20.704C13.4719 21.5359 14.208 22.208 15.168 22.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.808 10.496H17.984V11.232H19.808C20 11.232 20.16 11.072 20.16 10.88C20.192 10.656 20.032 10.496 19.808 10.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.456 12.8C19.456 12.608 19.296 12.448 19.104 12.448H18.016V13.184H19.104C19.296 13.152 19.456 12.992 19.456 12.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.192 14.72C20.192 14.528 20.032 14.368 19.8401 14.368H18.0161V15.104H19.8401C20.032 15.104 20.192 14.912 20.192 14.72Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27052_371112",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E33DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A59FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27052_371112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.df7dfea943010e66086cf834f1da2354.svg";
export { ForwardRef as ReactComponent };